var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header',[_vm._v(" cc-absence importer ")]),_c('div',{staticClass:"container"},[(_vm.step === 0)?_c('CollectorComponent'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }